import LoanTenor from './LoanTenor';

export default LoanTenor;
